import {checkLabelValueObject, emptyLabelValue, isLabelValue} from './checkObjects';
import {matchAccountType} from '../components/_helpers';
import {Account} from '../models/financial_infos/Account';

/**
 * Convert object with code and name to LabelValue
 * @param {{code: string, name: string}} codeAndNameObj
 * @param {LabelValue=} defaultLabel
 * @return {LabelValue}
 */
export const parseLabelValue = (codeAndNameObj, defaultLabel) => {
    if (typeof codeAndNameObj === 'object' && 'code' in codeAndNameObj && 'name' in codeAndNameObj && codeAndNameObj.code && codeAndNameObj.name) {
        return {value: codeAndNameObj.code, label: `${codeAndNameObj.code} - ${codeAndNameObj.name}`};
    } else if (isLabelValue(defaultLabel)) {
        return defaultLabel;
    } else {
        return emptyLabelValue();
    }
};

/**
 * Parse the accounts data received in the API.
 * @param {Object} accountDetails
 * @return {Account[]}
 */
export const parseAccounts = (accountDetails) => {
    if (Array.isArray(accountDetails) && accountDetails.length > 0) {
        return accountDetails.map((detail) => {
            const matchedAccountType = matchAccountType(detail['accountType']);
            return new Account(
                emptyLabelValue(),
                detail['glAccount'] ? parseLabelValue(detail['glAccount']) : '',
                matchedAccountType,
                detail['wbs'] ? parseLabelValue(detail['wbs']) : '',
                detail['costCenter'] ? parseLabelValue(detail['costCenter']) : '',
                detail['profitCenter'] ? parseLabelValue(detail['profitCenter']) : '',
                detail['allocation'] ? Number.parseFloat(detail['allocation']) : 100,
                'percentage',
                '',
                '',
                false,
            );
        });
    } else {
        return [new Account(
            emptyLabelValue(),
            emptyLabelValue(),
            emptyLabelValue(),
            emptyLabelValue(),
            emptyLabelValue(),
            emptyLabelValue(),
            100,
            'percentage',
            '',
            '',
            false,
        )];
    }
};

export const readAccounts = (accountDetails) => {
    if (Array.isArray(accountDetails) && accountDetails.length > 0) {
        return accountDetails.map((detail) => {
            const matchedAccountType = matchAccountType(detail['accountType']);
            return new Account(
                emptyLabelValue(),
                checkLabelValueObject(detail['glAccount']),
                matchedAccountType,
                checkLabelValueObject(detail['wbs']),
                checkLabelValueObject(detail['costCenter']),
                checkLabelValueObject(detail['profitCenter']),
                detail['allocation'] ? Number.parseFloat(detail['allocation']) : 100,
                'percentage',
                '',
                '',
                false,
            );
        });
    } else {
        return [new Account(
            emptyLabelValue(),
            emptyLabelValue(),
            emptyLabelValue(),
            emptyLabelValue(),
            emptyLabelValue(),
            emptyLabelValue(),
            100,
            'percentage',
            '',
            '',
            false,
        )];
    }
};

/**
 * Parse the plants data received in the API.
 * @param {Array|Object} plants - The plant(s) data to be parsed.
 * @return {{addressNumber: *, label: string, value: *}[]}
 */
export const parsePlants = (plants) => {
    const plantsArray = Array.isArray(plants) ? plants : [plants];

    return plantsArray.map((plant) => ({
        label: `${plant.code} - ${plant.name}`,
        value: plant.code,
        addressNumber: plant.addressNumber,
    }));
};
